/* eslint-disable jsx-a11y/alt-text */
import { Column } from "../../../../core/components/Column";
import { Container } from "../../../../core/components/Container";
import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";
import { CustomButton } from "../../../../core/components/CustomButton";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { Google } from "../../../../core/icons/Google";
import { Email } from "../../../../core/icons/Email";
import Checkbox from "../../../../core/components/CheckBox";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AppDispatch } from "../../../../core/store/store";
import { useDispatch } from "react-redux";
import { onLoginGmail } from "../store/auth/AuthThunk";
import { ModalSimple } from "../../../../core/components/Modal";
import { LogoTitleBlack } from "../../../../core/components/LogoTitle";
import { PrivacyPolicy } from "../components/PrivacyPolicy";
import { TermsUse } from "../components/TermsUse";
import { Toast } from "../../../../core/components/Toast";
import { setUserInfo } from "../../../profile/presentation/store/OnboardingSlice";
import { auth } from "../../../..";
import {
  apiServices,
  consumeAuthSessionMessage,
} from "../../../../core/utilities/ApiServices";
import { buildAuthQuery, getSafeNextPath } from "../routes/affiliateRedirect";
import { getPostLoginPath } from "../../../../core/utilities/accountRecovery";

export const LoginScreen = () => {
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);
  const [isLog, setIsLog] = useState(false);
  const [actionExecuted, setActionExecuted] = useState(false);
  const [title, setTitle] = useState("");
  const [text, setText] = useState<JSX.Element>();
  const dispatch: AppDispatch = useDispatch();
  const [isBanned, setIsBanned] = useState(false);
  const [sessionMessage, setSessionMessage] = useState("");
  const [searchParams] = useSearchParams();
  const referCode = searchParams.get('referCode');
  const intent = searchParams.get("intent");
  const nextPath = getSafeNextPath(searchParams.get("next"));
  const authQuery = buildAuthQuery(intent, searchParams.get("next"));
  const isAffiliateJoin = intent === "affiliate";

  useEffect(() => {
    const message = consumeAuthSessionMessage();
    if (message) {
      setSessionMessage(message);
    }
  }, []);
  
  useEffect(() => {
    if (referCode) {
      dispatch(
        setUserInfo({
          referral_code: referCode,
        })
      );
      apiServices.post("/affiliate/public/click", {
        code: referCode,
        source: "web_login",
        landingUrl: window.location.href,
      }).catch(() => undefined);
    }
  }, [dispatch, referCode]);
  
  //gmail
  const onRegisterLogin = async () => {
    setIsBanned(false);
    setIsLog(true);
    if (!isChecked) return;
    setIsLog(false);
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({ prompt: 'select_account' });
    try {
      const res = await signInWithPopup(auth, provider);
      const credential = GoogleAuthProvider.credentialFromResult(res);
      const encrypt_google_access = credential?.idToken;
      dispatch(
        onLoginGmail({
          token: encrypt_google_access ?? '',
        })
      ).then((resp) => {
        if (resp.meta.requestStatus === 'fulfilled') {
          navigate(getPostLoginPath((resp as any).payload, nextPath));
        } else {
          if (resp.meta.requestStatus === 'rejected') {
            if ((resp as any).error.message === "403") {
              setIsBanned(true);
            }
          }
        }
      });
    } catch (error: any) {
      if (error.code === 'auth/cancelled-popup-request') {
        return;
      }
    }
  };
  const onRegisterEmail = () => {
    setIsLog(true);
    if (!isChecked) return;
    setIsLog(false);
    navigate(`/auth/email?mode=login${authQuery ? `&${authQuery.slice(1)}` : ""}`);
  };

  const onPasswordLogin = () => {
    setIsLog(true);
    if (!isChecked) return;
    setIsLog(false);
    navigate(`/auth/password${authQuery}`);
  };

  const onResetPassword = () => {
    setIsLog(true);
    if (!isChecked) return;
    setIsLog(false);
    navigate(`/auth/email?mode=reset${authQuery ? `&${authQuery.slice(1)}` : ""}`);
  };

  const onPrivacyPolicy = () => {
    setTitle("Privacy Policy")
    setText(<PrivacyPolicy />);
    setActionExecuted(true);
  };

  const onTermsOfUse = () => {
    setTitle("Terms of Use")
    setText(<TermsUse />);
    setActionExecuted(true);
  };

  const handleModalClose = () => {
    setActionExecuted(false);
  };

  const handleCheckboxChange = (checked: boolean) => {
    setIsChecked(checked);
  };

  return (
    <Container className="w-full min-w-0 overflow-x-hidden flex flex-col md:w-1/2 md:justify-center">
      <LogoTitleBlack />
      <Column
        crossAxisAlignment="center"
        className="max-md:bg-black"
      >
        <Column
          mainAxisAlignment="center"
          className="relative box-border w-full min-w-0 max-w-full bg-white rounded-tl-3xl max-md:px-8 md:mx-24 md:w-1/2 max-md:py-14"
        >
          <TextComponent
            variant="h1"
            className="font-bold max-md:text-center max-md:break-words"
          >
            {isAffiliateJoin ? "Join the affiliate program" : "Welcome"}
          </TextComponent>
          <TextComponent
            variant="h6"
            className="mt-3 max-w-full text-gray-500 max-md:text-center max-md:break-words"
          >
            {isAffiliateJoin
              ? "Sign in or create your Unjabbed account first. Then you will go straight to the affiliate form."
              : "By signing in, you are indicating that you have read the Privacy Policy and agree to the Terms of Service"}
          </TextComponent>
          <CustomButton
            color="white"
            className="mt-9 max-w-full text-primary"
            onClick={onRegisterEmail}
          >
            <Row
              mainAxisAlignment="center" crossAxisAlignment="center"
              className="min-w-0 gap-3 text-center"
            >
              <Email />
              Continue with email code
            </Row>
          </CustomButton>
          <TextComponent variant="h7" className="mt-2 max-w-full text-gray-500 max-md:break-words">
            First time here? Use this option. After OTP, you can create your password.
          </TextComponent>
          <CustomButton
            color="white"
            className="mt-4 max-w-full text-primary"
            onClick={onPasswordLogin}
          >
            <Row
              mainAxisAlignment="center" crossAxisAlignment="center"
              className="min-w-0 gap-3 text-center"
            >
              Login with existing password
            </Row>
          </CustomButton>
          <TextComponent variant="h7" className="mt-2 max-w-full text-gray-500 max-md:break-words">
            Use this only if you already created a password before.
          </TextComponent>
          <button
            type="button"
            className="mt-2 max-w-full text-left text-primary underline max-md:break-words"
            onClick={onResetPassword}
          >
            Forgot password? Reset with email code
          </button>
          <button
            type="button"
            className="mt-6 text-center text-primary underline"
            onClick={() => navigate("/auth/login-help")}
          >
            Having trouble signing in?
          </button>
          <Row
            mainAxisAlignment="center" crossAxisAlignment="center"
            className="my-9 min-w-0 gap-4">
            <div className="h-[1px] min-w-0 flex-1 bg-gray-200" />
            <TextComponent variant="h6" className="shrink-0 text-center">
              Or continue with
            </TextComponent>
            <div className="h-[1px] min-w-0 flex-1 bg-gray-200" />
          </Row>
          <CustomButton
            color="white"
            className="max-w-full"
            onClick={onRegisterLogin}
          >
            <Row
              mainAxisAlignment="center" crossAxisAlignment="center"
              className="min-w-0 gap-3 text-center">
              <Google />
              Login in with google
            </Row>
          </CustomButton>
          <Row crossAxisAlignment="center" className="gap-2 mt-5">
            <Checkbox
              isChecked={isChecked}
              onCheckboxChange={handleCheckboxChange}
            />
            <TextComponent variant="h7" className="text-gray-500">
              <span>I agree to terms and conditions&nbsp;</span>
              <span className="text-primary max-md:absolute bottom-5 left-1/2 transform -translate-x-1/2">
                <button className="underline" onClick={onTermsOfUse}>Terms of use</button>
                &nbsp;&&nbsp;
                <button className="underline" onClick={onPrivacyPolicy}>Privacy Policy</button>
              </span>
            </TextComponent>
          </Row>
        </Column>
      </Column>
      {actionExecuted && (
        <ModalSimple
          title={title}
          actionExecuted={actionExecuted}
          onClose={handleModalClose}
        >
          {text}
        </ModalSimple>
      )}
      {isLog && !isChecked && (
        <Toast
          title="Information"
          message="You must agree our terms & conditions to use this app"
        />
      )}

      {isBanned && (
        <ModalSimple
          actionExecuted={isBanned}
          title="Account Banned"
          onClose={() => {
            setIsBanned(false)
          }}
        >
          <TextComponent variant="h5" className="text-center">
            Your account has been banned. Please contact support for assistance.
            <span className="font-bold text-primary ml-1 cursor-pointer" onClick={() => window.open("mailto:info@unjabbed.app")}>
              info@unjabbed.app
            </span>
          </TextComponent>
        </ModalSimple>
      )}
      {sessionMessage && (
        <ModalSimple
          actionExecuted={Boolean(sessionMessage)}
          title="Information"
          onClose={() => setSessionMessage("")}
        >
          <TextComponent variant="h5" className="text-center">
            {sessionMessage}
          </TextComponent>
        </ModalSimple>
      )}
    </Container>
  );
}
